import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './DiagnosticStyles.css';
import {COL_DEFS, defaultPDFParams, GridStyle, GRID_ENUMS, AGGREGATE_LEVEL_DEPTH} from "./Styles";
import {AgGridReact} from "ag-grid-react";
import {
    sortColumns,
    StudentCustomCellRenderer,
    cellStylePercentage
} from "./Utils";
import React, {useCallback, useEffect, useRef, useState} from "react";
import  {printDocWithColGroups} from "./pdfExport/printDoc";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import GroupByAggregateViewLegend from "./GroupByAggregateViewLegend";
// import axios from "@common/axios";

/*
    Version where students are in the first column and
 */
const GroupByAggregateViewV2 = props => {
    const {
        isLoading,
        setLoading,
        testAssignmentsData,
        students,
        studentIds,
        selectedTestIds,
        studentColOrder,
        selectedDifficultyIds,
        selectedAggregateLevel,
        headerAmount,
        contentType,
        openDialogCallback,
        triggerGenerate
    } = props;

    const curriculumKey = ['curriculumSyllabusId','curriculumTopicId','curriculumConceptId','skillId'],
        textKey = ['syllabusId','topicId','conceptId','skillId'],
        rowHeight = 28,
        REPORT_NAME = 'Results by Skills',
        NAME = 'NAME',
        syllabusCol = {field:'syllabus',headerName:'Course', testExamName:'Unit'},
        topicCol = {field:'topic',headerName:'Chapter', testExamName:'Area of Study'},
        conceptCol = {field:'concept',headerName:'Topic', testExamName:'Sub-topic'},
        skillCol = {field:'skill',headerName:'Skill', testExamName:'Skill'},
        ID = 'ID',
        defaultColDef = COL_DEFS.defaultColDef,
        correctColDef = {...COL_DEFS.correctColDef},
        studentCustomColDef = {
            headerClass: 'ch-bold',
            cellStyle: {borderRight:'1px solid lightgrey',borderTop:'unset!important'},
            cellRenderer: StudentCustomCellRenderer,
            width: 150,
            field: 'studentName',
            colId: 'student-name',
            headerName: 'Student name',
            pinned: 'left',
            pinnedOrder: 0,
            sortable: true,
            unSortIcon: true,
            comparator:(valueA,valueB)=>{
                return valueA.localeCompare(valueB);
            }
        },
        totalMarkColDef = COL_DEFS.totalMarkColDef,
        curriculumNames = [
            {fieldName:syllabusCol.field, propName:'curriculumSyllabusName',type:NAME},
            {fieldName:topicCol.field, propName:'curriculumTopicName',type:NAME},
            {fieldName:conceptCol.field, propName:'curriculumConceptName',type:NAME},
            {fieldName:skillCol.field, propName:'skillName',type:NAME}
        ],
        textNames = [
            {fieldName:syllabusCol.field, propName:'syllabusName',type:NAME},
            {fieldName:topicCol.field, propName:'topicName',type:NAME},
            {fieldName:conceptCol.field, propName:'conceptName',type:NAME},
            {fieldName:skillCol.field, propName:'skillName',type:NAME}
        ],
        curriculumFieldIds= [
            {fieldName:'conceptId', propName:'curriculumConceptId',type:ID},
            {fieldName:'topicId', propName:'curriculumTopicId',type:ID},
            {fieldName:'syllabusId', propName:'curriculumSyllabusId',type:ID},
            {fieldName:'skillId', propName:'skillId',type:ID}
        ],
        textFieldIds = [
            {fieldName:'conceptId', propName:'conceptId',type:ID},
            {fieldName:'topicId', propName:'topicId',type:ID},
            {fieldName:'syllabusId', propName:'syllabusId',type:ID},
            {fieldName:'skillId', propName:'skillId',type:ID}
        ],
        pinnedLeftCols = [],
        pinnedRightCols = [],
        aggregateLevels = {
            skill:{
                curriculum: {
                    key:curriculumKey,
                    fields:[
                        ...curriculumNames,
                        ...curriculumFieldIds
                    ]},
                text: {
                    key:textKey,
                    fields:[
                        ...textNames,
                        ...textFieldIds
                    ]
                },
                level:4
            },
            concept:{
                curriculum: {
                    key: curriculumKey.slice(0, 3),
                    fields: curriculumNames.slice(0, 3).concat(curriculumFieldIds.slice(0, 3))
                },
                text: {key:textKey.slice(0,3),
                    fields: textNames.slice(0,3).concat(textFieldIds.slice(0,3))
                },
                level:3
            },
            topic:{
                curriculum: {
                    key: curriculumKey.slice(0, 2),
                    fields: curriculumNames.slice(0, 2).concat(curriculumFieldIds.slice(0, 2))

                },
                text: {
                    key: textKey.slice(0,2),
                    fields: textNames.slice(0,2).concat(textFieldIds.slice(0, 2))
                },
                level:2
            },
            syllabus:{
                curriculum: {
                    key: curriculumKey.slice(0, 1),
                    fields: curriculumNames.slice(0, 1).concat(curriculumFieldIds.slice(0, 1))
                },
                text: {
                    key:textKey.slice(0,1),
                    fields: textNames.slice(0,1).concat(textFieldIds.slice(0, 1))
                },
                level:1
            }
        }

    totalMarkColDef.headerName = 'Student TOTAL';
    totalMarkColDef.headerClass = 'ch-bold';
    totalMarkColDef.width = 150;
    totalMarkColDef.headerStyle = {borderTop:'unset!important'};

    //remove sortable function for aggregate view
    delete correctColDef.sortable;
    delete correctColDef.unSortIcon;

    const gridRef = useRef(),
        [aggregateFieldNames,setAggregateFieldNames] = useState([]),
        [testResults,setTestResults] = useState([]),
        [questionResults,setQuestionResults] = useState([]),
        [viewData, setViewData] =  useState([]),
        // [unfilteredData, setUnfilteredData] =  useState([]),
        [headerHeightOffset,setHeaderHeightOffset] = useState(0),
        [graphData, setGraphData] =  useState([]),
        [initGraphData, setInitGraphData] =  useState([]),
        [dataMap, setDataMap] = useState({}),
        [columnDefs,setColumnDefs] = useState([]);

    useEffect(()=>{
        if (selectedTestIds === undefined || selectedTestIds.length === 0 || testAssignmentsData.length === 0 || students.length === 0) {
            return;
        }
        setGraphData([]);

        if(testAssignmentsData.length > 0){
            let tempQuestionResults = [],
                tempTestResults = [];

            testAssignmentsData.forEach((testAssignmentData) => {
                if(testAssignmentData.questionResultBeans != undefined) {
                    tempQuestionResults = [...tempQuestionResults, ...testAssignmentData.questionResultBeans];
                    tempTestResults = [...tempTestResults, ...testAssignmentData.testResultBeans];
                }
            });

            setTestResults(tempTestResults);
            setQuestionResults(tempQuestionResults);
            setLoading(false);
        }else{
            setLoading(false);
        }


        // if(Object.entries(studentMap).length > 0){
        //     // setDataMap(studentMap);
        //     // setInitStudentMap(studentMap);
        // }else{
        //     setLoading(false);
        // }
        setLoading(false);
    },[triggerGenerate]);


    useEffect(()=>{
        // if (selectedTestIds.length === 0 || Object.keys(dataMap).length === 0) {
        //     return;
        // }
        // setGraphData(Object.values(dataMap));
        // setInitGraphData(Object.values(dataMap));

    },[dataMap]);

    // const initCols = [syllabusColDef,topicColDef,conceptColDef,skillColDef,correctColDef];

    // useEffect(()=>{

        // if(students.length > 0) {
        //     addStudentColDefs(students, initCols,false, openDialogCallback);
        // }
        // setColumnDefs(initCols);
    // }, [students]);

    // useEffect(() => {
        // showHideUserCols(gridRef,columnDefs,studentIds);
    // }, [studentIds]);

    const doSortData = (data) => {
        return sortColumns(data, studentColOrder);
    }

    useEffect(() => {
        if (questionResults.length > 0) {
            mapQuestionResults();
        }
    }, [questionResults, studentIds, contentType, selectedDifficultyIds, selectedAggregateLevel]);

    const getContentLevels = () => {
        const colArr = [];
        const levelArr = ['Unit', 'Area of Study', 'Sub-topic', 'Skill'];

        for(let i = 0; i < headerAmount; i++){
            const level = levelArr[i];
            const colDef = {headerName:level, field:level.toLowerCase(), colId:level.toLowerCase(), headerClass:'ch-bold', width:106, pinned:'left'};
            colArr.push(colDef);
        }

        for(let i = 0; i < colArr.length; i++){
            if(colArr[i+1] !== undefined){
                colArr[i].children = [colArr[i+1]];
            }
        }

        return colArr[0];
    }

    const mapColumnDefs = (contentCols)=>{

        pinnedLeftCols.push(studentCustomColDef);
        pinnedRightCols.push(totalMarkColDef);

        const columnDefsArr = [...pinnedLeftCols, ...contentCols, ...pinnedRightCols];

        setColumnDefs(columnDefsArr);
    }

    const mapQuestionResults = ()=>{
        const aggregateLevel = aggregateLevels[selectedAggregateLevel][contentType];
        let aggregateDisplayMap = {};
        let aggregateDataMap = {};
        let userTotals = {};
        let syllabusMap = new Map(),
            topicMap = new Map(),
            conceptMap = new Map(),
            skillMap = new Map();

        const studentIdsMap = {};

        for (const item of studentIds) {
            studentIdsMap[item] = item;
        }

        students.forEach((student)=>{
            aggregateDataMap[GRID_ENUMS.USER + student.userId] = {questionMaxMark: 0, questionMarkTotal: 0};
            aggregateDisplayMap[GRID_ENUMS.USER + student.userId] = {
                firstName: student.firstName,
                lastName: student.lastName,
                studentName: student.lastName + ', ' + student.firstName,
                userId: student.userId,
                columnType: GRID_ENUMS.USER,
                callback: openDialogCallback
            };
        });

        aggregateDisplayMap[GRID_ENUMS.CORRECT_PERCENT] = {[studentCustomColDef.field]: '% CORRECT', [totalMarkColDef.field]: GRID_ENUMS.NOT_AVAILABLE};

        questionResults.forEach((questionResult,idx) =>{
            if(questionResult.hasOwnProperty('conceptId')) {
                if (selectedDifficultyIds.length === 0 || selectedDifficultyIds.includes(questionResult.questionDiffLevel)) {
                    const userKey = GRID_ENUMS.USER + questionResult.userId;
                    let key = '';

                    for (let i = 0; i < aggregateLevel.key.length; i++) {
                        const aggregateKey = aggregateLevel.key[i];
                        if (i === aggregateLevel.key.length - 1) {
                            key += questionResult[aggregateKey];
                        } else {
                            key += questionResult[aggregateKey] + '-';
                        }
                    }

                    const syllabusKey = aggregateLevel.key[0],
                        topicKey =  aggregateLevel.key[1],
                        conceptKey =  aggregateLevel.key[2],
                        skillKey =  aggregateLevel.key[3];

                    if (syllabusKey && questionResult[syllabusKey] !== undefined && !syllabusMap.has(questionResult[syllabusKey])) { //syllabus level
                         const syllabus = {
                             flex:1,
                             cellStyle: cellStylePercentage,
                            width: 250,
                            colId: questionResult[syllabusKey] + '',
                            field: questionResult[syllabusKey] + '',
                            headerName: questionResult.syllabusName,
                        };
                         if(contentType === GRID_ENUMS.CURRICULUM && questionResult.hasOwnProperty('curriculumSyllabusName')){
                             syllabus.headerName = questionResult.curriculumSyllabusName;
                         }
                         if(aggregateLevel.key.length > 1){ //includes topics
                            syllabus.children = [];
                        }
                         syllabusMap.set(questionResult[syllabusKey], syllabus);
                    }
                    if (syllabusKey && questionResult[syllabusKey] !== undefined && topicKey && questionResult[topicKey] !== undefined && !topicMap.has(questionResult[syllabusKey] + '-' + questionResult[topicKey])) {
                        const topic = {
                            flex:1,
                            cellStyle: cellStylePercentage,
                            mapKey: questionResult[syllabusKey],
                            width: 225,
                            // syllabusId: questionResult.syllabusId,
                            colId: questionResult[syllabusKey] + '-' + questionResult[topicKey],
                            field: questionResult[syllabusKey] + '-' + questionResult[topicKey],
                            topicSequence:questionResult.topicSequence,
                            headerName: questionResult.topicName,
                        };
                        if(contentType === GRID_ENUMS.CURRICULUM && questionResult.hasOwnProperty('curriculumTopicName')){
                            topic.headerName = questionResult.curriculumTopicName;
                        }
                        if(aggregateLevel.key.length > 2){ //includes concepts
                            topic.children = [];
                        }
                        topicMap.set(questionResult[syllabusKey] + '-' + questionResult[topicKey], topic);
                    }
                    if (syllabusKey && questionResult[syllabusKey] !== undefined && topicKey && questionResult[topicKey] !== undefined && conceptKey && questionResult[conceptKey] !== undefined && !conceptMap.has(questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey])) {
                        const concept = {
                            flex:1,
                            cellStyle: cellStylePercentage,
                            mapKey: questionResult[syllabusKey] + '-' + questionResult[topicKey],
                            width: 200,
                            // topicId: questionResult.topicId,
                            colId: questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey],
                            field: questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey],
                            conceptSequence:questionResult.conceptSequence,
                            headerName: questionResult.conceptName
                        }
                        if(contentType === GRID_ENUMS.CURRICULUM && questionResult.hasOwnProperty('curriculumConceptName')){
                            concept.headerName = questionResult.curriculumConceptName;
                        }
                        if(aggregateLevel.key.length > 3){ // includes skills
                            concept.children = [];
                        }
                        conceptMap.set(questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey], concept);
                    }

                    if (syllabusKey && topicKey && conceptKey && skillKey && questionResult[syllabusKey] !== undefined && topicKey && questionResult[topicKey] !== undefined && conceptKey && questionResult[conceptKey] !== undefined && !skillMap.hasOwnProperty(questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey] + '-' + questionResult[skillKey])) {
                        const skill = {
                            flex:1,
                            cellStyle: cellStylePercentage,
                            mapKey: questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey],
                            width: 200,
                            // topicId: questionResult.topicId,
                            colId: questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey] + '-' + questionResult[skillKey],
                            field: questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey] + '-' + questionResult[skillKey],
                            headerName: questionResult.skillName
                        }
                        skillMap.set(questionResult[syllabusKey] + '-' + questionResult[topicKey] + '-' + questionResult[conceptKey] + '-' + questionResult[skillKey], skill);
                    }

                    if(!aggregateDataMap.hasOwnProperty(userKey)){
                        // no result for this user return;
                        return;
                    }

                    if (!aggregateDataMap[userKey].hasOwnProperty(key)) {
                        aggregateDataMap[userKey][key] = {questionMark: 0, count: 0, questionMaxMark: 0, percent: 0};
                    }

                    if (!userTotals.hasOwnProperty(questionResult.userId)) {
                        userTotals[questionResult.userId] = {userKey: userKey, userMarks: 0, userMaxMarks: 0};
                    }

                    if (!aggregateDataMap.hasOwnProperty(key)) {
                        aggregateDataMap[key] = {questionMaxMark: 0, questionMarkTotal: 0};
                    }

                    if(questionResult.skipped){
                        questionResult.mark = 0;
                    }
                    aggregateDataMap[userKey][key].questionMark += questionResult.mark;

                    const questionMaxMark = questionResult.adaptiveMaxMark !== 0 ? questionResult.adaptiveMaxMark : questionResult.maxMark;
                    aggregateDataMap[userKey][key].questionMaxMark += questionMaxMark;


                    if (studentIdsMap.hasOwnProperty(questionResult.userId)) {
                        aggregateDataMap[key].questionMarkTotal += questionResult.mark;
                        aggregateDataMap[key].questionMaxMark += questionMaxMark;
                    }

                    userTotals[questionResult.userId].userMarks += questionResult.mark;
                    userTotals[questionResult.userId].userMaxMarks += questionMaxMark;
                    userTotals[questionResult.userId].performance = 100 * userTotals[questionResult.userId].userMarks / userTotals[questionResult.userId].userMaxMarks;

                    const totalStudentValue = Math.round(100 * aggregateDataMap[key].questionMarkTotal / aggregateDataMap[key].questionMaxMark);
                    const rowPercentValue = aggregateDataMap[key].questionMaxMark !== 0 ? totalStudentValue : 0;

                    aggregateDisplayMap[GRID_ENUMS.CORRECT_PERCENT][key] = rowPercentValue + '%';

                    // }

                    const studentValue = Math.round(100 * aggregateDataMap[userKey][key].questionMark / aggregateDataMap[userKey][key].questionMaxMark);
                    const percentValue = isNaN(studentValue) ? 0 : studentValue;
                    if(!questionResult.skipped){
                        aggregateDataMap[userKey][key].percent = percentValue;
                        aggregateDataMap[userKey][key].percentDisplay = percentValue + '%';
                        aggregateDisplayMap[userKey][key] = percentValue + '%';
                        aggregateDisplayMap[userKey].answered = true;
                    }
                    aggregateDataMap[userKey][key].count++;
                    const performance = Math.round(userTotals[questionResult.userId].performance);
                    if(isNaN(performance)) {
                        aggregateDisplayMap[userKey][totalMarkColDef.field] = '';
                        aggregateDisplayMap[userKey].performance = 0;
                    } else {
                        aggregateDisplayMap[userKey][totalMarkColDef.field] = performance + '%';
                        aggregateDisplayMap[userKey].performance = performance;
                    }
                }
            }
        });

        conceptMap = new Map([...conceptMap.entries()].sort((a, b) => a[1].conceptSequence - b[1].conceptSequence));
        topicMap = new Map([...topicMap.entries()].sort((a, b) => a[1].topicSequence - b[1].topicSequence));

        const aggregateData = [...Object.values(aggregateDisplayMap).filter((row)=>{
            return studentIdsMap.hasOwnProperty(row.userId) || !row.hasOwnProperty('userId');
        })];

        const aggregateLevelFieldNames = [];
        aggregateLevel.fields.forEach(field => {
            if(field.type === NAME){
                aggregateLevelFieldNames.push(field.fieldName);
            }
        });

        if(aggregateLevel.key.length > 3){
            skillMap.forEach((entry) => {
                conceptMap.get(entry.mapKey).children.push(entry);
            });
        }

        if(aggregateLevel.key.length > 2){
            conceptMap.forEach((entry) => {
                topicMap.get(entry.mapKey).children.push(entry);
            });
        }

        if(aggregateLevel.key.length > 1) {
            topicMap.forEach((entry) => {
                syllabusMap.get(entry.mapKey).children.push(entry);
            });
        }

        mapColumnDefs([...syllabusMap.values()]);

        if(syllabusMap.size === 0 &&
            topicMap.size === 0 &&
            conceptMap.size === 0 &&
            skillMap.size === 0){
            setViewData([]);
            setInitGraphData([]);
        }else{
            setViewData(aggregateData);
            setInitGraphData(aggregateData);
        }


        setAggregateFieldNames(aggregateLevelFieldNames);
        setLoading(false);
    }

    useEffect(() => {
        if (viewData.length === 0) {
            setGraphData([])
            return;
        }
        setLoading(false);
        setGraphData(doSortData(viewData));
    }, [viewData, studentColOrder]);


    const onGridReady = ()=>{
        setLoading(false);
    }

    const onExportCSV = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({fileName:REPORT_NAME});
    }, []);

    const onExportPDF = useCallback((aggregateLevel) => {
        defaultPDFParams.PDF_COLUMN_WIDTH = 80;
        printDocWithColGroups(defaultPDFParams,gridRef.current.api,REPORT_NAME,AGGREGATE_LEVEL_DEPTH[aggregateLevel]);
    }, []);

    const getToolBar = () => (
        <div className="export-toolbar genBtn-blk">
            <button type="button" className="btn btn-default excel genBtn smallBtn"
                    onClick={onExportCSV}
            >Export CSV <FileDownloadIcon/>
            </button>
            <button type="button" className="btn btn-default reset genBtn smallBtn"
                    onClick={()=>{onExportPDF(selectedAggregateLevel)}}
            >Export PDF <FileDownloadIcon/>
            </button>
        </div>
    );

    return(
        <div>
            <GroupByAggregateViewLegend/>
            {!isLoading && graphData && graphData.length > 0 && getToolBar() }
            {graphData && graphData.length > 0 &&
                <div id="order-by-aggregate-view"
                     className={'ag-theme-balham ch-general-table-ag-grid rounded-top aggregateV2'}
                     style={{
                         height: ((rowHeight * graphData.length) + (GridStyle.AGGREGATE_HEADER_HEIGHT * headerAmount) + GridStyle.GRID_PADDING + GridStyle.HORIZONTAL_SCROLLBAR_PADDING - Math.abs(headerHeightOffset)) + 'px',
                         marginTop: Math.abs(headerHeightOffset)
                     }}>
                    <AgGridReact
                        ref={gridRef}
                        suppressPropertyNamesCheck={true}
                        suppressHorizontalScroll={true}
                        suppressRowTransform={true}
                        defaultColDef={defaultColDef}
                        rowHeight={rowHeight}
                        headerHeight={GridStyle.AGGREGATE_HEADER_HEIGHT}
                        columnDefs={columnDefs}
                        rowData={graphData}
                        onGridReady={onGridReady}
                    />
                </div>
            }
            {graphData && graphData.length === 0 &&
                <div className="ch-dashboard-warning-text">No relevant data to display</div>
            }
        </div>
    )
}

export default GroupByAggregateViewV2;
